import type { UserInput } from '@skop-app/lib-domain/types'

import { hasCompletedOnboarding } from './onboarding.persistence'
import {
  hasAcceptedRealTeamMembership,
  type OrganizationMembershipForOnboarding,
} from './isOnboardingRequired'

export type ShouldProbeManageActivityParams = {
  user: UserInput | undefined
  organizations: OrganizationMembershipForOnboarding[] | undefined
}

export const shouldProbeManageActivity = (
  params: ShouldProbeManageActivityParams,
): boolean => {
  if (!params.user?.id) return false

  if (hasCompletedOnboarding(params.user.preferences)) {
    return false
  }

  if (params.organizations === undefined) {
    return false
  }

  const organizations = params.organizations ?? []

  if (hasAcceptedRealTeamMembership(organizations)) return false

  const shops = (params.user as { shop?: unknown[] } | undefined)?.shop
  if (Array.isArray(shops) && shops.length > 0) return false

  return true
}
